export default "__VITE_ASSET__b1e4cd1b__"